import Vue from "vue";

Vue.filter('trimSpaces', function (value) {
    return value.replace(/\s+$/,"");
});
import moment from 'moment'
require('moment/locale/es'); // Moment Spanish Translation
// Filters

Vue.filter('pretty', function (value) {
	return JSON.stringify(JSON.parse(value), null, 2);
});

Vue.filter('formatDate', function (value) {
	if (value) {
		return moment(String(value)).format('DD/MM/YYYY')
	}
});

Vue.filter('unescape', function (value) {
	return unescape(value);
});

Vue.filter('currency', function (value) {
	return '$ ' + parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
});

Vue.filter('formatDateTime', function (value) {
	if (value) {
		return moment(String(value)).format('DD/MM/YYYY HH:mm')
	}
});

Vue.filter('formatDateTimeTwo', function (value) {
	if (value) {
		return moment(String(value)).format('HH:mm:ss')
	}
});
Vue.filter('formatDateTimeSecond', function (value) {
	if (value) {
		return value.format('DD/MM/YYYY HH:mm:ss')
	}
});

Vue.filter('firstUpperCase', function (value) {
	return value[0].toUpperCase() + value.slice(1);

});

Vue.filter('fromNow', function (v) {
	return moment(v).fromNow()
});

Vue.filter('truncateCustom', function (v, arg) {
	if(!v) return '';
	return v.substring(0, arg) + '...';
});

Vue.filter('json', function (value) {
	return JSON.stringify(value, null, 2);
});







